import { Typography, Grid, Box, Button } from '@mui/material';

// Rendered by the top-level ErrorBoundary when a render error is caught. Self-contained
// so it still shows even if config or layout is what failed. Lives inside ThemeProvider.
function ErrorBody() {
    return (
        <Box sx={{ minHeight: '100dvh', display: 'grid', placeItems: 'center', px: 2 }}>
            <Grid container spacing={0} direction='column' justifyContent='center' alignItems='center'>
                <Typography align='center' variant='m_logo' color='primary.main' sx={{ mb: '0.6em' }}>
                    Loise
                </Typography>
                <Typography
                    align='center'
                    variant='m_overline'
                    color='primary.main'
                    sx={{ mb: 'clamp(32px, 4vh, 64px' }}>
                    administrator tool
                </Typography>
                <Typography align='center' variant='body1' sx={{ mt: 4 }}>
                    Something went wrong
                </Typography>
                <Typography align='center' variant='body2' color='text.secondary' sx={{ mt: 1 }}>
                    An unexpected error occurred. Please reload and try again.
                </Typography>
                <Button variant='contained' onClick={() => window.location.reload()} sx={{ mt: 4 }}>
                    Reload
                </Button>
            </Grid>
        </Box>
    );
}

export { ErrorBody };
